import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=388eda05&scoped=true"
import script from "./Partner.vue?vue&type=script&setup=true&lang=js"
export * from "./Partner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Partner.vue?vue&type=style&index=0&id=388eda05&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388eda05",
  null
  
)

export default component.exports